import React from 'react'

export interface ScoreBarProps {
  /** Placar da equipe/atleta A */
  scoreA: number | null
  /** Placar da equipe/atleta B */
  scoreB: number | null
  /** Identificador do vencedor */
  winner?: 'A' | 'B' | null
}

const ScoreBar: React.FC<ScoreBarProps> = ({ scoreA, scoreB, winner }) => {
  if (scoreA == null || scoreB == null) {
    return null
  }
  const total = scoreA + scoreB
  const percA = total > 0 ? (scoreA / total) * 100 : 50
  const percB = 100 - percA
  const colorA = winner === 'A' ? '#0dcaf0' : '#dc3545'
  const colorB = winner === 'B' ? '#0dcaf0' : '#dc3545'

  return (
    <div className="d-flex align-items-center w-100 my-3">
      <span className="fw-bold me-2" style={{ color: colorA }}>
        {scoreA}
      </span>
      <div className="progress flex-grow-1 me-2 ms-2" style={{ height: 8 }}>
        <div
          className="progress-bar"
          style={{ width: `${percA}%`, backgroundColor: colorA }}
        />
        <div
          className="progress-bar"
          style={{ width: `${percB}%`, backgroundColor: colorB }}
        />
      </div>
      <span className="fw-bold" style={{ color: colorB }}>
        {scoreB}
      </span>
    </div>
  )
}

export default ScoreBar
